import { render } from "./OrderHeaderChangeActions.vue?vue&type=template&id=4dab180c&scoped=true&ts=true"
import script from "./OrderHeaderChangeActions.vue?vue&type=script&lang=ts"
export * from "./OrderHeaderChangeActions.vue?vue&type=script&lang=ts"

import "./OrderHeaderChangeActions.vue?vue&type=style&index=0&id=4dab180c&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dab180c"]])

export default __exports__